// Human-readable texts shared by the portal and the game page.

import type { GameInfo, GameResult } from '../net/client';

export function resultText(r: GameResult | null, g: Pick<GameInfo, 'host' | 'guest'>): string {
  if (!r) return '';
  const who = (owner: string): string => (owner === 'host' ? g.host : owner === 'guest' ? g.guest ?? '' : 'компьютер');
  switch (r.kind) {
    case 'victory': {
      const won = (r.teams ?? []).filter((t) => r.winners?.includes(t.name));
      return 'Победа: ' + won.map((t) => `${t.name} (${who(t.owner)})`).join(', ');
    }
    case 'draw':
      return 'Ничья';
    case 'resigned':
      return `${r.by} сдался, победил ${r.winner}`;
    case 'aborted':
      return r.by ? `Прервана (${r.by})` : 'Прервана';
    case 'cancelled':
      return 'Отменена до начала';
    case 'expired':
      return 'Соперник так и не пришёл';
  }
}

export function scoreText(r: GameResult | null): string {
  return (r?.teams ?? []).map((t) => `${t.name}: ${t.vp}`).join(' · ');
}

/** "whose input the game waits for", for the lobby */
export function phaseText(phase: string, turn: string | null): string {
  const who = turn ? `: ${turn}` : '';
  switch (phase) {
    case 'turn':
      return 'Ход' + who;
    case 'equip':
      return 'Экипировка и высадка' + who;
    case 'end':
      return 'Итоги партии';
    case 'setup':
    case 'scenarios':
    case 'options':
      return 'Выбор сценария и настроек' + who;
    default:
      return turn ? 'Ход' + who : '';
  }
}

const dtf = new Intl.DateTimeFormat('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
export const dateText = (t: number | null): string => (t ? dtf.format(new Date(t)) : '—');

export function durationText(from: number | null, to: number | null): string {
  if (!from || !to) return '';
  const m = Math.round((to - from) / 60000);
  return m < 60 ? `${m} мин` : `${Math.floor(m / 60)} ч ${m % 60} мин`;
}
